// extracted by mini-css-extract-plugin
module.exports = {"warningList":"style-module_warningList__1VSaX93xUgW0er43sqfnYp"};